"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { CircleCheck as CheckCircle, Smile, Shield, Headphones } from 'lucide-react';
export default function ThePraiseSpaceStandard() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const features = [{
    id: 1,
    icon: CheckCircle,
    title: "Cleanliness",
    description: "Immaculate spaces maintained to the highest standards, ensuring every guest enjoys a pristine environment."
  }, {
    id: 2,
    icon: Smile,
    title: "Comfort",
    description: "Fully furnished properties with modern amenities that provide the warmth and ease of home."
  }, {
    id: 3,
    icon: Shield,
    title: "Reliability",
    description: "Consistent, dependable service you can trust across all our prime locations and properties."
  }, {
    id: 4,
    icon: Headphones,
    title: "Support",
    description: "Exceptional guest support available when you need it, ensuring a seamless stay experience."
  }];
  return <section id="the-praise-space-standard" className="bg-background py-24 md:py-48">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div ref={containerRef} className="grid grid-cols-12 gap-8 md:gap-12">
          {}
          <div className="col-span-12 md:col-span-4 relative">
            {}
            <div className="absolute -top-12 left-8 w-0.5 h-24" style={{
            backgroundColor: "var(--secondary)"
          }}></div>
            <div className="absolute top-12 left-8 w-1 h-1 rounded-lg" style={{
            backgroundColor: "var(--secondary)"
          }}></div>

            <h2 className={`text-4xl md:text-5xl font-default font-normal tracking-tight leading-tight transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <span style={{
              display: "block",
              marginLeft: "2rem"
            }}>The</span>
              Standard
            </h2>
          </div>

          {}
          <div className="col-span-12 md:col-span-8">
            {}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-6">
              {features.map((feature, i) => {
              const Icon = feature.icon;
              return <div key={feature.id} data-index={i}>
                    <Card className={`h-full border border-border transition-all duration-300 hover:border-b-4 group cursor-default`} style={{
                  borderBottomColor: "var(--secondary)"
                }}>
                      <CardContent className="pt-6 flex flex-col gap-4">
                        {}
                        <div className="transition-colors duration-300" style={{
                      color: "var(--muted-foreground)"
                    }}>
                          <Icon className="w-6 h-6 group-hover:text-secondary transition-colors duration-300" strokeWidth={1.5} />
                        </div>

                        {}
                        <h4 className="font-default font-semibold text-lg md:text-base leading-tight text-foreground">
                          {feature.title}
                        </h4>

                        {}
                        <p className="font-sans text-sm md:text-sm leading-relaxed text-muted-foreground">
                          {feature.description}
                        </p>
                      </CardContent>
                    </Card>
                  </div>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="hidden md:grid grid-cols-12 gap-8 mt-24 opacity-20 pointer-events-none">
          {Array.from({
          length: 12
        }).map((_, i) => <div key={i} className="h-px" style={{
          backgroundColor: "var(--border)"
        }}></div>)}
        </div>
      </div>
    </section>;
}